import React, { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FeedKey, UserFeedFollowGroupFragment } from 'api';
import { Buttons, FollowToggle, PrivateGroupIcon, TableCellWithOverflow } from 'components';
import { useFollowed } from 'hooks';
import theme from 'theme';

import ImageCell from '../GroupCells/Image';
import TitleCell from '../GroupCells/Title';
import MembersCell from '../GroupCells/Members';
import { isRequiredGroup } from 'features/groups/helpers';

const styles = {
  row: {
    backgroundColor: theme.palette.common.white,
    height: '100px',
  },
  cell: {
    border: 'none',
  },
  icon: {
    padding: theme.spacing(0, 2),
  },
  actionButton: {
    width: 10,
  },
  greyButton: {
    color: 'grey.600',
  },
  borderLeft: {
    borderBottomLeftRadius: 16,
    borderTopLeftRadius: 16,
  },
  borderRight: {
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16,
  },
} as const;

interface Props {
  group: UserFeedFollowGroupFragment;
}

const ClientRow: FC<Props> = ({ group }) => {
  const { t } = useTranslation();
  const { required } = useFollowed();

  function renderActionButton() {
    return (
      <FollowToggle source={group} type={FeedKey.Group}>
        {({ isFollowing, loading, onClick }) =>
          isFollowing ? (
            <Buttons.Secondary onClick={onClick} disabled={loading}>
              {t('common:leave')}
            </Buttons.Secondary>
          ) : (
            <Buttons.Primary onClick={onClick}>{t('common:join')}</Buttons.Primary>
          )
        }
      </FollowToggle>
    );
  }

  return (
    <TableRow sx={styles.row} key={group.id}>
      <TableCell padding="none" sx={{ ...styles.cell, ...styles.borderLeft }}>
        <ImageCell group={group} />
      </TableCell>
      <TableCell sx={{ ...styles.icon, ...styles.cell }} align="center">
        <PrivateGroupIcon group={group} type="index" />
      </TableCell>
      <TableCellWithOverflow padding="none" sx={styles.cell}>
        <TitleCell group={group} />
      </TableCellWithOverflow>
      <TableCell align="center" sx={styles.cell}>
        <MembersCell group={group} />
      </TableCell>
      <TableCell sx={{ ...styles.cell, ...styles.borderRight }}>
        {isRequiredGroup(group, required) ? null : renderActionButton()}
      </TableCell>
    </TableRow>
  );
};

export default ClientRow;
